const InitialState = {
  data: [],
  currentPage: 1,
  dataPerPage: 10,
};

export default InitialState;
